import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  TextField,
  Button
} from "@mui/material";
import { AlertTriangle } from "lucide-react";

const RejectReasonDialog = ({
  isOpen,
  onClose,
  targetItemTitle,
  onConfirmReject
}) => {
  const [reason, setReason] = useState("");

  const handleConfirm = () => {
    onConfirmReject(reason || "Changes requested on uploaded material.");
    setReason("");
    onClose();
  };

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{ sx: { borderRadius: "12px" } }}
    >
      <DialogTitle sx={{ display: "flex", alignItems: "center", gap: 1, py: 1.5 }}>
        <AlertTriangle size={18} color="#ef4444" />
        <Typography sx={{ fontWeight: 700, fontSize: "0.95rem", color: "#0f172a" }}>
          Reject Request
        </Typography>
      </DialogTitle>

      <DialogContent sx={{ pt: "10px !important" }}>
        <Typography variant="body2" sx={{ color: "#64748b", mb: 1.5, fontSize: "0.8125rem" }}>
          Please specify the reason for rejecting <b>{targetItemTitle}</b>. The designer will see this feedback note to make corrections and re-upload.
        </Typography>

        <Typography
          variant="caption"
          sx={{ fontWeight: 700, color: "#334155", display: "block", mb: 0.5 }}
        >
          Reason for Rejection *
        </Typography>
        <TextField
          fullWidth
          multiline
          rows={3}
          size="small"
          placeholder="e.g. Please update guest speaker photo, change logo alignment, or fix date typo..."
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          sx={{
            "& .MuiOutlinedInput-root": {
              borderRadius: "8px",
              fontSize: "0.8125rem"
            }
          }}
        />
      </DialogContent>

      <DialogActions sx={{ px: 2.5, pb: 2 }}>
        <Button
          onClick={onClose}
          size="small"
          sx={{ textTransform: "none", fontSize: "0.8rem", color: "#64748b" }}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          color="error"
          size="small"
          onClick={handleConfirm}
          disabled={!reason.trim()}
          sx={{
            textTransform: "none",
            borderRadius: "6px",
            fontWeight: 600,
            fontSize: "0.8rem",
            px: 2
          }}
        >
          Submit Reject Request
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RejectReasonDialog;
